// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1yS7a","title":"Info_title__2w-Ig","links":"Info_links__23KkR","link":"Info_link__2ECcU","logo":"Info_logo__qaIoZ"};